import { useStaticQuery, graphql } from 'gatsby'

// :::: GET Article from Article title ::::
export const getReadTimeFromBlog = (title) => {
  const { allStrapiBlog } = useStaticQuery(allStrapiReadTimeQuery);
  const blog = allStrapiBlog.nodes.filter((node) => node.title === title);
  return blog[0];
}

const allStrapiReadTimeQuery = graphql`
query {
    allStrapiBlog {
      nodes {
        title
        body {
          data {
            body
          }
        }
      }
    }
  }
`